.section {
  position: relative;
  min-height: 100svh;
  background: var(--color-background);
  isolation: isolate;
}
